/**
 * Iconos SVG personalizados para nodos en el mapa
 * @module components/map/NodeIcons
 */

import L from 'leaflet'
import { NodeType } from '@/types/nodes'
import { NODE_COLORS } from '@/constants'

// SVGs para cada tipo de nodo
const NODE_SVGS: Record<NodeType, string> = {
  // OLT - Rack/Server con antena
  OLT: `
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="12" width="24" height="24" rx="3" fill="{{color}}" stroke="white" stroke-width="2"/>
      <rect x="12" y="16" width="16" height="3" rx="1" fill="white" opacity="0.9"/>
      <rect x="12" y="21" width="16" height="3" rx="1" fill="white" opacity="0.7"/>
      <rect x="12" y="26" width="16" height="3" rx="1" fill="white" opacity="0.5"/>
      <circle cx="26" cy="31" r="2" fill="#22c55e"/>
      <line x1="20" y1="12" x2="20" y2="4" stroke="white" stroke-width="2"/>
      <circle cx="20" cy="4" r="3" fill="{{color}}" stroke="white" stroke-width="1.5"/>
      <path d="M14 8 L20 4 L26 8" stroke="white" stroke-width="1.5" fill="none"/>
    </svg>
  `,
  
  // POP - Edificio/Centro de datos
  POP: `
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="10" width="28" height="26" rx="2" fill="{{color}}" stroke="white" stroke-width="2"/>
      <rect x="10" y="14" width="6" height="6" rx="1" fill="white" opacity="0.9"/>
      <rect x="18" y="14" width="6" height="6" rx="1" fill="white" opacity="0.9"/>
      <rect x="26" y="14" width="4" height="4" fill="#22c55e"/>
      <rect x="10" y="22" width="6" height="6" rx="1" fill="white" opacity="0.7"/>
      <rect x="18" y="22" width="6" height="6" rx="1" fill="white" opacity="0.7"/>
      <rect x="26" y="22" width="4" height="4" fill="#22c55e"/>
      <rect x="14" y="30" width="12" height="6" rx="1" fill="white"/>
      <line x1="20" y1="10" x2="20" y2="4" stroke="{{color}}" stroke-width="3"/>
      <polygon points="15,6 20,2 25,6" fill="{{color}}" stroke="white" stroke-width="1"/>
    </svg>
  `,
  
  // NAP - Caja de distribución con splitter
  NAP: `
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="24" height="24" rx="4" fill="{{color}}" stroke="white" stroke-width="2"/>
      <circle cx="20" cy="20" r="8" fill="white" opacity="0.2"/>
      <path d="M12 20 L18 20 L20 16 L20 24 L22 20 L28 20" stroke="white" stroke-width="2" fill="none"/>
      <circle cx="12" cy="20" r="2" fill="white"/>
      <circle cx="28" cy="16" r="1.5" fill="white"/>
      <circle cx="28" cy="20" r="1.5" fill="white"/>
      <circle cx="28" cy="24" r="1.5" fill="white"/>
      <rect x="10" y="28" width="4" height="2" rx="0.5" fill="white" opacity="0.7"/>
      <rect x="18" y="28" width="4" height="2" rx="0.5" fill="white" opacity="0.7"/>
      <rect x="26" y="28" width="4" height="2" rx="0.5" fill="white" opacity="0.7"/>
    </svg>
  `,
  
  // CIERRE - Caja de empalme (domo/horizontal)
  CIERRE: `
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="20" cy="20" rx="16" ry="10" fill="{{color}}" stroke="white" stroke-width="2"/>
      <ellipse cx="20" cy="20" rx="12" ry="6" fill="white" opacity="0.2"/>
      <line x1="4" y1="20" x2="10" y2="20" stroke="white" stroke-width="2"/>
      <line x1="30" y1="20" x2="36" y2="20" stroke="white" stroke-width="2"/>
      <rect x="14" y="16" width="12" height="8" rx="1" fill="white" opacity="0.3"/>
      <line x1="16" y1="18" x2="16" y2="24" stroke="white" stroke-width="1"/>
      <line x1="20" y1="18" x2="20" y2="24" stroke="white" stroke-width="1"/>
      <line x1="24" y1="18" x2="24" y2="24" stroke="white" stroke-width="1"/>
    </svg>
  `,
  
  // CLIENTE - Casa con señal WiFi
  CLIENTE: `
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 22 L20 10 L34 22 L34 36 L6 36 Z" fill="{{color}}" stroke="white" stroke-width="2"/>
      <rect x="16" y="26" width="8" height="10" fill="white"/>
      <rect x="10" y="24" width="5" height="5" fill="white" opacity="0.7"/>
      <rect x="25" y="24" width="5" height="5" fill="white" opacity="0.7"/>
      <path d="M15 8 Q20 4 25 8" stroke="white" stroke-width="1.5" fill="none" opacity="0.5"/>
      <path d="M13 11 Q20 5 27 11" stroke="white" stroke-width="1.5" fill="none" opacity="0.7"/>
      <path d="M11 14 Q20 6 29 14" stroke="white" stroke-width="1.5" fill="none" opacity="0.9"/>
      <circle cx="20" cy="8" r="2" fill="white"/>
    </svg>
  `,
  
  // POSTE - Poste de luz con cable
  POSTE: `
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="17" y="8" width="6" height="30" rx="1" fill="{{color}}" stroke="white" stroke-width="1.5"/>
      <rect x="8" y="10" width="24" height="4" rx="1" fill="{{color}}" stroke="white" stroke-width="1.5"/>
      <circle cx="10" cy="12" r="2" fill="white" opacity="0.8"/>
      <circle cx="30" cy="12" r="2" fill="white" opacity="0.8"/>
      <line x1="4" y1="12" x2="8" y2="12" stroke="white" stroke-width="1.5" stroke-dasharray="2 1"/>
      <line x1="32" y1="12" x2="36" y2="12" stroke="white" stroke-width="1.5" stroke-dasharray="2 1"/>
      <rect x="15" y="20" width="10" height="3" rx="0.5" fill="white" opacity="0.5"/>
      <path d="M20 38 L16 38 L18 34 L22 34 L24 38 L20 38" fill="{{color}}" stroke="white" stroke-width="1"/>
    </svg>
  `,
}

// Crear icono para un tipo de nodo
export function createNodeIcon(
  nodeType: NodeType,
  options: {
    size?: number
    isSelected?: boolean
    isSelectedForCable?: boolean
    /** Orden del nodo dentro de la ruta de cable en edición/trazado (1-based) */
    cableOrderNumber?: number
    /** Anillo naranja para selección múltiple en mapa */
    inMultiSelection?: boolean
    customIcon?: string
    customColor?: string
    showBadge?: boolean
    badgeText?: string
    badgeColor?: string
  } = {}
): L.DivIcon {
  const {
    size = 32,
    isSelected = false,
    isSelectedForCable = false,
    cableOrderNumber,
    inMultiSelection = false,
    customIcon,
    customColor,
    showBadge = false,
    badgeText = '',
    badgeColor = '#ef4444',
  } = options

  const color = customColor || (isSelectedForCable ? '#eab308' : NODE_COLORS[nodeType])
  const actualSize = isSelected || isSelectedForCable ? size * 1.3 : size
  
  // Usar icono personalizado si se proporciona, sino usar el SVG del tipo
  let iconContent: string
  
  if (customIcon) {
    // Si es una URL de imagen
    if (customIcon.startsWith('http') || customIcon.startsWith('data:') || customIcon.startsWith('/')) {
      iconContent = `
        <div style="
          width: ${actualSize}px; 
          height: ${actualSize}px; 
          border-radius: 50%; 
          border: 3px solid ${color};
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
          overflow: hidden;
        ">
          <img src="${customIcon}" style="width: 80%; height: 80%; object-fit: contain;" />
        </div>
      `
    } else {
      // Si es un emoji o texto
      iconContent = `
        <div style="
          width: ${actualSize}px; 
          height: ${actualSize}px; 
          border-radius: 50%; 
          background: ${color};
          border: 3px solid white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: ${actualSize * 0.5}px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        ">
          ${customIcon}
        </div>
      `
    }
  } else {
    // Usar SVG del tipo de nodo
    const svg = NODE_SVGS[nodeType].replace(/\{\{color\}\}/g, color)
    iconContent = `
      <div style="
        width: ${actualSize}px; 
        height: ${actualSize}px;
        filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
        ${isSelected ? 'filter: drop-shadow(0 0 8px rgba(59, 130, 246, 0.8));' : ''}
        ${isSelectedForCable ? 'filter: drop-shadow(0 0 8px rgba(234, 179, 8, 0.8));' : ''}
      ">
        ${svg}
      </div>
    `
  }

  // Agregar badge si es necesario
  if (showBadge && badgeText) {
    iconContent = `
      <div style="position: relative;">
        ${iconContent}
        <div style="
          position: absolute;
          top: -4px;
          right: -4px;
          background: ${badgeColor};
          color: white;
          font-size: 10px;
          font-weight: bold;
          padding: 2px 5px;
          border-radius: 10px;
          min-width: 16px;
          text-align: center;
          border: 1px solid white;
          box-shadow: 0 1px 3px rgba(0,0,0,0.3);
        ">
          ${badgeText}
        </div>
      </div>
    `
  }

  if (inMultiSelection) {
    iconContent = `
      <div style="
        display: inline-block;
        padding: 2px;
        border-radius: 50%;
        box-shadow: 0 0 0 3px #f97316, 0 2px 10px rgba(0,0,0,0.25);
      ">
        ${iconContent}
      </div>
    `
  }

  // Badge con número de orden para postes/nodos en ruta de cable
  if (isSelectedForCable && typeof cableOrderNumber === 'number' && cableOrderNumber > 0) {
    iconContent = `
      <div style="position: relative; display: inline-block;">
        ${iconContent}
        <div style="
          position: absolute;
          top: -6px;
          left: -6px;
          background: #eab308;
          color: #1f2937;
          font-size: 11px;
          font-weight: 700;
          min-width: 18px;
          height: 18px;
          padding: 0 4px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
          box-shadow: 0 1px 3px rgba(0,0,0,0.4);
          line-height: 1;
        ">${cableOrderNumber}</div>
      </div>
    `
  }

  return L.divIcon({
    className: 'custom-node-icon',
    html: iconContent,
    iconSize: [actualSize, actualSize],
    iconAnchor: [actualSize / 2, actualSize / 2],
    popupAnchor: [0, -actualSize / 2],
  })
}

// Crear icono con indicador de estado
export function createNodeIconWithStatus(
  nodeType: NodeType,
  status: 'online' | 'offline' | 'warning' | 'maintenance',
  options: {
    size?: number
    isSelected?: boolean
  } = {}
): L.DivIcon {
  const statusColors = {
    online: '#22c55e',
    offline: '#ef4444',
    warning: '#f59e0b',
    maintenance: '#6366f1',
  }
  
  const { size = 32, isSelected = false } = options
  const color = NODE_COLORS[nodeType]
  const actualSize = isSelected ? size * 1.3 : size
  const svg = NODE_SVGS[nodeType].replace(/\{\{color\}\}/g, color)
  
  const iconContent = `
    <div style="position: relative;">
      <div style="
        width: ${actualSize}px; 
        height: ${actualSize}px;
        filter: drop-shadow(0 2px 4px rgba(0,0,0,0.3));
      ">
        ${svg}
      </div>
      <div style="
        position: absolute;
        bottom: -2px;
        right: -2px;
        width: 10px;
        height: 10px;
        background: ${statusColors[status]};
        border-radius: 50%;
        border: 2px solid white;
        box-shadow: 0 1px 3px rgba(0,0,0,0.3);
      "></div>
    </div>
  `

  return L.divIcon({
    className: 'custom-node-icon',
    html: iconContent,
    iconSize: [actualSize, actualSize],
    iconAnchor: [actualSize / 2, actualSize / 2],
    popupAnchor: [0, -actualSize / 2],
  })
}

// Exportar los SVGs para uso en otros componentes
export { NODE_SVGS }
